import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import CreateAddress from 'components/form/AddressSelector/Items/CreateAddress/CreateAddress';

const enhance = compose(withTranslation('StopAddress'));

export default enhance(CreateAddress);
